import { render, staticRenderFns } from "./curriculumView.vue?vue&type=template&id=04986386&scoped=true"
import script from "./curriculumView.vue?vue&type=script&lang=js"
export * from "./curriculumView.vue?vue&type=script&lang=js"
import style0 from "./curriculumView.vue?vue&type=style&index=0&id=04986386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04986386",
  null
  
)

export default component.exports